import React from 'react'
import { Container } from 'semantic-ui-react'

const about = () => (
  <Container>
    <div style={{maxWidth: '360px'}}>
      <h1>About</h1>
      <p>I am a creative technologist and have worked on projects ranging from interactive museum exhibits (Science
        Museum, London)
        to self-organising wireless networks for monitoring vineyards (Intel Research, USA).</p>
      <p>I form and lead teams to deliver innovative solutions for complex problems small or large. Following user
        centred design principles I am able to quickly and reliably concept, design, develop and deploy complex systems
        removing smoothing the bumps and hiccups through iteration. Often combining hardware and software my projects
        are used within organisations as well as externally exhibited for the public and professionals to interact
        with.</p>
      <p>I have just finished working at Spyscape - an amazing multi-sensory experience that brings to life the fascinating
        world of hacking and spying which can be visited in New York but is being designed and built in London.</p>
      <p>I have also worked for Nokia (London), Microsoft (Seattle), Intel Research (Portland, Oregon) and IDEO (London)
        designing and developing new digital products and services.</p>
      <p>I hold degrees in Computer Related Design MA from the Royal College of Art, MSc Mechatronics from Hull
        University
        and a Cybernetics BSc from the University of Reading.</p>
    </div>
  </Container>
)

export default about



// WEBPACK FOOTER //
// ./src/modules/about/About.js